import React from 'react';
import { GoClockFill } from "react-icons/go";
import { FaPlay } from "react-icons/fa";
import { Link } from 'react-router-dom';
import "./CivilCard.css";
import aboutimg from "../../../../Image/aboutimg.png"
import defaultNewsImage from '../CivilTopSection/defaultNewsImage.png'

function CivilCard({ CardData }) {
    // Check if CardData is defined before mapping over it
    if (!CardData || !Array.isArray(CardData)) {
        return null; // or display a loading indicator, error message, etc.
    }

    function convertTimestamp(originalTimestamp) {
        const originalDate = new Date(originalTimestamp);
        return originalDate.toLocaleString('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    }

    function isValidUrl(string) {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    }

    const stripHtmlAndTruncate = (html, title = '', length = 5000) => {
        if (!html) return '';

        let text = html;

        // Quick check: if it looks like JSON, try to parse it
        if (typeof html === 'string' && (html.startsWith('[') || html.startsWith('{'))) {
            try {
                const parsed = JSON.parse(html);
                if (Array.isArray(parsed)) {
                    text = parsed.map(p => p.text || '').join(' ');
                }
            } catch (e) {
                // Not valid JSON, fall back to string processing
            }
        }

        // 1. Remove style, script, xml, head tags and their contents (this fixes the VML issue)
        text = text.replace(/<(style|script|xml|head)\b[^>]*>[\s\S]*?<\/\1>/gi, '');

        // 2. Remove HTML comments and Word-specific conditional comments
        text = text.replace(/<!--[\s\S]*?-->/g, '');
        text = text.replace(/<!\[[\s\S]*?\]>/g, '');

        // 3. ULTRA-AGGRESSIVE cleaning for Word/VML junk
        // This catches the exact pattern: v:* {behavior...} ... X-NONE X-NONE
        text = text.replace(/[vow]\\?:\*[\s\S]*?X-NONE\s+X-NONE/gi, '');
        text = text.replace(/\.shape[\s\S]*?X-NONE\s+X-NONE/gi, '');
        
        // Remove any remaining CSS rules that might have survived (selector { properties })
        text = text.replace(/[a-z0-9\\?:\*\.-]+\s*\{[^{}]*\}/gi, '');
        
        // Remove common Word metadata strings
        text = text.replace(/Normal\s+0\s+false\s+false\s+false\s+false\s+EN-US\s+X-NONE\s+X-NONE/gi, '');
        text = text.replace(/mso-[a-z-]+:[^;]+;/gi, ''); // Remove mso properties
        text = text.replace(/\{[^}]*behavior\s*:\s*url\s*\([^)]*VML[^)]*\)[^}]*\}/gi, '');

        // 4. Replace other tags with space instead of empty string to avoid merging words
        text = text.replace(/<[^>]*>?/gm, ' ');

        // 5. Handle common HTML entities
        text = text.replace(/&nbsp;/g, ' ')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&rsquo;/g, "'")
            .replace(/&lsquo;/g, "'")
            .replace(/&ldquo;/g, '"')
            .replace(/&rdquo;/g, '"')
            .replace(/&quot;/g, '"')
            .replace(/&mdash;/g, '—')
            .replace(/&ndash;/g, '–')
            .replace(/&hellip;/g, '…');

        // 6. Remove multiple spaces and trim
        text = text.replace(/\s+/g, ' ').trim();

        // If description starts with the title, remove it to avoid redundancy
        if (title && typeof title === 'string') {
            const cleanTitle = title.trim();
            const normalizedTitle = cleanTitle.toLowerCase().replace(/[^a-z0-9]/g, '');
            
            // Check first 200 chars for a normalized match of the title
            const searchRange = text.substring(0, Math.max(cleanTitle.length + 100, 200));
            const normalizedSearch = searchRange.toLowerCase().replace(/[^a-z0-9]/g, '');
            
            if (normalizedSearch.startsWith(normalizedTitle)) {
                // If we found a normalized match, find the best skip index
                let skipIndex = -1;
                
                // Normalize apostrophes for comparison
                const textForSearch = text.toLowerCase().replace(/[’‘]/g, "'");
                const titleForSearch = cleanTitle.toLowerCase().replace(/[’‘]/g, "'");
                
                if (textForSearch.startsWith(titleForSearch)) {
                    skipIndex = titleForSearch.length;
                } else {
                    const index = textForSearch.indexOf(titleForSearch);
                    if (index !== -1 && index < 100) {
                        skipIndex = index + titleForSearch.length;
                    }
                }
                
                if (skipIndex !== -1) {
                    text = text.substring(skipIndex).trim();
                }
            }
        }

        // AGGRESSIVE HEADER SKIPPING
        const headersToSkip = [
            /^INTRODUCTION\b/i,
            /^WHY IN NEWS\b/i,
            /^BACKGROUND\b/i,
            /^CONCLUSION\b/i,
            /^EXPLANATION\b/i,
            /^SUMMARY\b/i,
            /^CONTEXT\b/i
        ];
        
        let changed = true;
        while (changed) {
            changed = false;
            // Remove leading punctuation/spaces
            text = text.replace(/^[:\-\s\u2013\u2014\.\,]+/, '').trim();
            
            // Then check for headers
            for (let regex of headersToSkip) {
                if (regex.test(text)) {
                    text = text.replace(regex, '').trim();
                    changed = true;
                    break;
                }
            }
        }
        
        // Final trim
        text = text.replace(/^[:\-\s\u2013\u2014\.\,]+/, '').trim();

        return text.length > length ? text.substring(0, length) + "..." : text;
    };

    return (
        <>
            {CardData.map((item, index) => {
                // Extract category tags for the current item
                const categoryTagsArray = item?.CategoryTag?.split(',');
                
                // FALLBACK LOGIC: If Subtitle exists and is not empty, use it. Otherwise use Description.
                const rawContent = (item.Subtitle && item.Subtitle.trim() !== '') 
                    ? item.Subtitle 
                    : (item.subtitle && item.subtitle.trim() !== '')
                        ? item.subtitle
                        : (item.Description || item.description || '');

                return (
                    <div className='CivilCard-background' key={index}>
                        <div className="CivilCard-box">
                            <div className="text-center CivilCard-imgs">
                                <Link to={`/readmore/News/${item.ImageAlt}`}>
                                    {/* <img src={isValidUrl(item.Image) ? item.Image : aboutimg} className='CivilCard-img' alt={`Images ${index}`} loading="lazy" /> */}
                                    <img src={item.Image} onError={(e) => {
                                        e.target.src = aboutimg;
                                    }} className='CivilCard-img' alt={`Images ${index}`} loading="lazy" />
                                </Link>
                            </div>
                            <div className="currenttextsec d-flex justify-content-between">
                                <div className='current-box1'>
                                    <ul className='d-flex civilcard-tags'>
                                        {categoryTagsArray?.map((tag, tagIndex) => (
                                            <li key={tagIndex} className='badge m-1 bg-danger p-2 bg-pureorange'>{tag.trim()}</li>
                                        ))}
                                    </ul>
                                    <h6>
                                        <Link className='list-group-item' to={`/readmore/News/${item.ImageAlt}`}>
                                            {item?.Title}
                                        </Link>
                                    </h6>
                                    <p className="mb-1"><GoClockFill /> {convertTimestamp(item.PublishDate)} {item.WrittenBy && <span className="ms-2">| By: {item.WrittenBy}</span>}</p>
                                    <p className="civil-card-description">{stripHtmlAndTruncate(rawContent, item.Title, 400)}</p>
                                    <div className="current-box2">
                                        <Link to={`/readmore/News/${item.ImageAlt}`} className='list-group-item bg-darkblue p-2 fw-bold text-white'>Read More <FaPlay className='text-pureorange' /></Link>
                                        {/* <Link to={`/readmore/News/${item.ImageAlt}`} className='p-2'>read more</Link> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </>
    );
}

export default CivilCard;